<template>
  <div class="wrapper">
    <div v-if="loading_submit" class="loading_overlay">
      <div class="loading_spinner"></div>
    </div>
    <div v-if="error_message" class="error_overlay">
      <div class="error_message">{{ error_message }}</div>
    </div>
    <div class="container_wrapper">
      <div class="scanner_section" :style="{ border: `20px solid ${scannerColor}` }">
          <!-- <qrcode-stream v-if="showScanner" ref="qrStream" @decode="onDecode" @init="onInit"></qrcode-stream> -->
          <div id="qr-reader"></div>
         <!-- <p v-if="decodedContent">Result: {{ decodedContent }}</p> -->
      </div>
      <div class="list_section">
        <div class="card" v-for="item in items" :key="item.id" >
          <div class="card_left">
            <img v-bind:src="getPhoto(item.get_photo)" class="card_image">
          </div>
          <div class="card_right">
            <div class="card_text_name">{{item.name}}</div>
            <div class="card_text_class">{{item.class_name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { Html5Qrcode } from "html5-qrcode";

import axios from 'axios'
import EventBus from '@/eventBus';
import ikid from '@/services/ikid'
import { sendMessageToDiscord } from '@/discordUtils';
import moment from 'moment';

import Pusher from 'pusher-js';
import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default {

  components: { QrcodeStream },
  props: {
    onScanSuccess: Function
  },
  data () {
    return {
      data:[],
      data_checkin:[],
      data_checkout:[],
      id: '',
      class_id: [],
      class_name: [],
      dad_id: [],
      dad_name: [],
      mom_id:[],
      mom_name:[],
      selectedItems: [],
      selectedItemsCheckIn: [],
      selectedItemsCheckOut: [],
      form:{
        value: '',
        from:'portal',
      },
      value: '',
      error: '',
      camera_hide: false,
      result_hide: true,
      message: '',
      message_hide: true,
      loading_submit: false,
      error_message: '',
      decodedContent: null,
      items: [],
      meta: [],
      metaLog: [],
      current_page: 1,
      per_page: 10000,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      showScanner: true,
      scannerColor: 'black',
      pusher_data: {
        kid_name: null,
        kid_class_id: null,
        now_action: null,
        from: null,
      },
      refreshTimer: null,
      refreshQueued: false,
      refreshInFlight: false,
      refreshLastRunAt: 0,
      refreshIntervalMs: 2500,
      heartbeatIntervalMs: 8000,
      heartbeatTimer: null,
      pusherClient: null,
      lastEventId: null,
      qrCodeScanner: null,
      scannerId: "qr-reader",
      test_cameraId: null,
      test_cameraId2: null,
      is_onscan: false,
    }
  },

  created(){

  },

  mounted(){
    // this.$refs.text.focus();
    this.startScanner();

    this.loadData()
    EventBus.$on('TABLE_UPDATE_USHER_PAGE', (data) => {
      if(data){
          this.queueRealtimeRefresh();
      }
    });

    // Keep scan page lightweight: no pusher-triggered refresh here.
    this.heartbeatTimer = setInterval(() => {
      this.loadData()
    }, this.heartbeatIntervalMs)
  },
  beforeDestroy() {
    this.stopScanner();
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
      this.refreshTimer = null
    }
    if (this.pusherClient) {
      this.pusherClient.disconnect()
      this.pusherClient = null
    }
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  },
  methods: {
    startScanner() {
      this.qrCodeScanner = new Html5Qrcode(this.scannerId);

      const config = {
        fps: 10,
        qrbox: { width: 150, height: 150 },
        rememberLastUsedCamera: true,
        aspectRatio: 1.0
      };

      Html5Qrcode.getCameras()
        .then(cameras => {
          if (cameras && cameras.length) {
            // 🔄 Try to find a camera labeled "back"
            const backCamera = cameras.find(cam =>
              cam.label.toLowerCase().includes("back")
            );

            const cameraId = backCamera ? backCamera.id : cameras[0].id;
            this.test_cameraId = cameras;
            this.test_cameraId2 = cameraId;

            this.qrCodeScanner.start(
              { facingMode: "environment" },
              config,
              (decodedText) => {
                if (this.is_onscan) return; // Prevent multiple scans
                console.log("QR Code matched: ", decodedText);
                // this.onScanSuccess(decodedText);
                this.onDecode(decodedText);
                // Optional: pause scanning after successful scan
                // this.stopScanner();
              },
              (errorMessage) => {
                // console.warn(`QR Code no match: ${errorMessage}`);
              }
            );
          }
        })
        .catch(err => {
          console.error("Camera error:", err);
        });
    },
    stopScanner() {
      if (this.qrCodeScanner) {
        this.qrCodeScanner.stop()
          .then(() => {
            this.qrCodeScanner.clear();
          })
          .catch(err => {
            console.error("Stop failed:", err);
          });
      }
    },
    onDecode(result) {
      this.stopScanner(); // Stop the scanner to prevent multiple scans
      this.is_onscan = true; // Set flag to prevent multiple scans
      this.decodedContent = result;
      this.form.ikid_id = 1;
      this.form.qrcode = result.replace('#', '').toUpperCase();
      this.form.status = 4;

      this.loading_submit = true;

      ikid.changeStatusKidQueue(this.form)
        .then(res => {
          this.scannerColor = '#66ff66';
          EventBus.$emit('TABLE_UPDATE_USHER_PAGE', true);
        })
        .catch((err) => {
          // color #ff6666
          this.scannerColor = '#ff6666';
          const params = {
            title: 'Error',
            mode: 'danger',
            data: err.response?.data?.message || 'Unknown error'
          };
          EventBus.$emit('OPEN_MODAL_ALERT', params);
          this.showErrorMessage(err.response?.data?.message || 'Unknown error');
        })
        .finally(() => {
          this.decodedContent = null;
          // Force re-render scanner to allow same QR code
          this.showScanner = false;
          setTimeout(() => {
            this.showScanner = true;
            this.is_onscan = false; // Reset flag after processing
            this.startScanner();
          }, 1500); // 300ms is usually enough

          // Reset scanner color after 300ms
          setTimeout(() => {
            this.scannerColor = 'black';
          }, 300);
        });
        this.loading_submit = false;
    },
    onInit(promise) {
      promise.then(() => {
        console.log('Camera permission granted')
      }).catch(error => {
        console.error('Camera init error:', error)
      })
    },
    loadData() {
      this.loading_submit = true;
      const params = {
        if_modified_since_event_id: this.lastEventId,
        limit: 200,
      }
      ikid.getIkidQueue(params)
      .then(res => {
          if (res.not_changed) {
            this.lastEventId = res.event_id || this.lastEventId
            return
          }
          this.lastEventId = res.event_id || this.lastEventId

          let getData = Array.isArray(res.data) ? res.data : []
          this.items = getData
          this.meta = {
              total: getData.length,
              current_page: 1,
              per_page: getData.length,
              from: getData.length > 0 ? 1 : 0,
              to: getData.length,
              is_active: 1,
              ikid_class_name: this.ikid_class_name,
              checkin_status: this.checkin_status

          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
      this.loading_submit = false;
    },
    queueRealtimeRefresh() {
      this.refreshQueued = true
      this.flushRealtimeRefresh()
    },
    flushRealtimeRefresh() {
      if (!this.refreshQueued || this.refreshInFlight || this.refreshTimer) return
      const elapsed = Date.now() - this.refreshLastRunAt
      const waitMs = Math.max(0, this.refreshIntervalMs - elapsed)

      this.refreshTimer = setTimeout(async () => {
        this.refreshTimer = null
        if (!this.refreshQueued || this.refreshInFlight) return
        this.refreshQueued = false
        this.refreshInFlight = true
        this.refreshLastRunAt = Date.now()
        try {
          await this.loadData()
        } finally {
          this.refreshInFlight = false
          if (this.refreshQueued) this.flushRealtimeRefresh()
        }
      }, waitMs)
    },
    getPhoto(data) {
      if (data === null || data === ' ') {
        return 'data:image/png;base64,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';
      } else {
        return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename;
      }
    },
    isSelected(id){
      const isExist = this.selectedItems.find(i => i === id)
      return !!isExist
    },
    handleSelect(data){
      const isExist = this.selectedItems.find(i => i === data.id)
      if(isExist){
        this.selectedItems = this.selectedItems.filter(i => i !== data.id)
      }else{
        this.selectedItems.push(data.id)
      }
    },
    showErrorMessage(message) {
      this.error_message = message;
      setTimeout(() => {
        this.error_message = '';
      }, 2000);
    },

  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Itim&display=swap');

#qr-reader {
  margin: auto;
  max-width: 200px;
  width: 100%;
}

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: white;
  margin: auto;
  box-sizing: border-box;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.loading_overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading_spinner {
  width: 70px;
  height: 70px;
  border: 10px solid #fff;
  border-top: 10px solid #ffcc00;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error_overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.error_message {
  font-size: 1.5rem;
  font-family: "Itim", cursive;
  color: #fff;
  background-color: #ff4444;
  padding: 20px 40px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.container_wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.scanner_section {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 30%;
  background-color: black;
  /* padding: 20px; */
  border: 20px solid black;
}
.scanner_content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  background-color: black;
}
.scanner_result {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40%;
  background-color: green;
}
.list_section {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  height: 70%;
  background-color: lightblue;
  gap: 10px;
  padding: 10px 0;
}

.card {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 10px;
  margin: 0 10px;
  min-height: 80px;
}

.card_left {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card_image {
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 10px;
  border: 2px solid #ffcc00;
  background: #eee;
}

.card_right {
  width: 70%;
  display: flex;
  flex-direction: column; /* Stack name and class vertically */
  align-items: flex-start;
  justify-content: center;
  padding-left: 20px;
}

.card_text_name {
  font-family: "Itim", cursive;
  font-size: 1.5rem; /* Make name bigger */
  color: #333;
  font-weight: bold;
  margin-bottom: 4px;
}

.card_text_class {
  font-family: "Itim", cursive;
  font-size: 1.1rem;
  color: #333;
  opacity: 0.8;
}
</style>
